// extracted by mini-css-extract-plugin
module.exports = {"FixedWidthColumn":"Column_FixedWidthColumn__2dkfC","show-first":"Column_show-first__2Tzoi"};